import { z } from 'zod';

// These helpers bridge shared Zod summary schemas to Drizzle relation
// `columns` selections. They exist so backend queries can derive their
// selected relation fields from the same schema definitions used to validate
// the API response shape, instead of maintaining two separate field lists.
export const buildColumnSelectionFromSchema = <T extends z.ZodObject<any>>(
  schema: T
) =>
  Object.fromEntries(
    Object.keys(schema.shape).map((key) => [key, true])
  ) as Record<keyof z.infer<T>, true>;

export const buildRelationSelectionFromSchemas = <
  T extends Record<string, z.ZodObject<any>>,
>(
  schemas: T
) =>
  Object.fromEntries(
    Object.entries(schemas).map(([key, schema]) => [
      key,
      { columns: buildColumnSelectionFromSchema(schema) },
    ])
  ) as {
    [K in keyof T]: {
      columns: Record<keyof z.infer<T[K]>, true>;
    };
  };
